import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { faq } from '../data/mock';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import CTASection from '../components/CTASection';

const FAQPage = () => {
  const { language, t } = useLanguage();
  const questions = faq[language];

  return (
    <main>
      {/* Hero */}
      <section className="relative py-20 bg-gradient-to-br from-purple-900 via-purple-800 to-purple-900 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 right-20 w-72 h-72 bg-orange-400 rounded-full blur-3xl" />
          <div className="absolute bottom-20 left-20 w-96 h-96 bg-purple-400 rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t.faq.title}
          </h1>
          <p className="text-xl text-purple-100 max-w-2xl mx-auto">
            {t.faq.subtitle}
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-3xl mx-auto px-4">
          <Accordion type="single" collapsible className="space-y-4">
            {questions.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden"
              >
                <AccordionTrigger className="px-6 py-5 hover:no-underline hover:bg-gray-50 transition-colors">
                  <div className="flex items-center gap-4 text-left">
                    <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <HelpCircle className="text-purple-600" size={20} />
                    </div>
                    <span className="font-semibold text-gray-900">
                      {item.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5">
                  <div className="pl-14 text-gray-600 leading-relaxed">
                    {item.answer}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Contact CTA */}
          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-4">
              {language === 'sv' 
                ? 'Hittar du inte svaret på din fråga?' 
                : "Can't find the answer to your question?"
              }
            </p>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-700 font-medium"
            >
              {language === 'sv' ? 'Kontakta oss' : 'Contact us'}
            </a>
          </div>
        </div>
      </section>

      <CTASection />
    </main>
  );
};

export default FAQPage;
